module.exports = __webpack_public_path__ + "static/media/portfolio-dpr.2edd1f5a.png";